module.exports = __webpack_public_path__ + "static/media/i_kids.b0345005.png";